import React, { useEffect, useState } from "react";
import { Form, Input, Switch, Button, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { notify } from "../../customs/NotifyProvider";
import { AddonServices } from "../../Services/AddonServices";
import { ProductServices } from "../../Services/ProductServices";
import { formatDateTime } from "../Customs/formatDateTime";
import { ENDPOINTS } from "../../Services/ENDPOINTS";

const { TextArea } = Input;

const AddS = ({ editorId, closeDrawer, getAddonServices }) => {
  const [form] = Form.useForm();
  const [id, setId] = useState(editorId);
  const [addonData, setAddonData] = useState([]);

  const baseUrl = ENDPOINTS.asset_service;

  const isEdit = id !== undefined && id !== null;

  useEffect(() => {
    if (isEdit) {
      getEditValues();
    }
  }, [id]);

  const getEditValues = async () => {
    try {
      const request = await AddonServices.ServicesById(id);

      if (request?.status && request?.data) {
        setAddonData(request.data);

        const img = request.data.upload_img
          ? [
            {
              uid: "-1",
              name: request.data.upload_img,
              status: "done",
              url: `${ENDPOINTS.cleanBase}${request.data.upload_img}`,
            },
          ]
          : [];

        form.setFieldsValue({ ...request.data, service_img: img });
      } else {
        notify.error("Something went wrong", request?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // convert event → fileList
  const normFile = (e) => {
    if (Array.isArray(e)) return e;
    return e?.fileList;
  };

  const handleDeleteImage = async (image) => {

    console.log("Deleted file:", image);

    const baseUrl = ENDPOINTS.asset_service;
    // if (!image.startsWith(baseUrl)) {
    //   console.error("Invalid URL, does not match base path");
    //   return;
    // }


    const fileName = image.split("/").pop();

    console.log(fileName); // 1764758263029-772168584.jpg


    // const fileName = image.replace(baseUrl, "").split("?")[0];
    try {
      const response = await ProductServices.deleteUploadedFile({
        file_path: 'assets/service',
        file_name: fileName
      });
      if (response.status) {
        const payload = {
          upload_img: '',
          updated_on: formatDateTime()
        };
        response = await AddonServices.updateServices(id, payload);
      } else {
        notify.warning("warning", response.message);
      }
      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };


  const handleFinish = async (values) => {
    try {
      const fd = new FormData();


      fd.append("name", values.name);
      fd.append("description", values.description);
      fd.append("status", values.status ? 1 : 0);
      fd.append("page_slug", values.page_slug || '#');
      fd.append("added_by", null);

      fd.append(
        "added_on",
        isEdit ? addonData?.added_on : formatDateTime()
      );
      fd.append("updated_on", formatDateTime());


      const imgFile = values.service_img?.[0];

      if (values.service_img && values.service_img.length > 0) {
        const fileObj = values.service_img[0].originFileObj;
        if (fileObj) {
          fd.append("upload_img", fileObj);
        }
      }

      let response;

      if (isEdit) {
        response = await AddonServices.updateServices(id, fd);
      } else {
        response = await AddonServices.addServices(fd);
      }

      if (response.status) {
        notify.success("Success", response.message);
        closeDrawer();
        getAddonServices();
        setId(null);
      } else {
        notify.error("Error", response.message);
      }
    } catch (error) {
      console.log(error);
      notify.error("Error", "Something went wrong");
    }
  };

  return (
    <Form form={form} layout="vertical" onFinish={handleFinish}>
      <Form.Item
        name="name"
        label="Service Name"
        rules={[{ required: true, message: "Please enter service name" }]}
      >
        <Input placeholder="Enter service name" />
      </Form.Item>

      <Form.Item
        name="description"
        label="Description"
        rules={[{ required: true, message: "Please enter description" }]}
      >
        <TextArea rows={4} placeholder="Enter description" />
      </Form.Item>

      <Form.Item
        name="status"
        label="Status"
        valuePropName="checked"
        initialValue={true}
      >
        <Switch />
      </Form.Item>

      {/* ⭐ IMAGE UPLOAD */}
      <Form.Item
        name="service_img"
        label="Upload Service Image"
        valuePropName="fileList"
        getValueFromEvent={normFile}
      >
        <Upload
          listType="picture"
          beforeUpload={(file, fileList) => {
            const currentFiles = form.getFieldValue("service_img") || [];
            if (currentFiles.length > 0) {
              notify.warning(
                "Image already exists",
                "To upload a new image, please delete the previous uploaded image first."
              );
              return Upload.LIST_IGNORE; // prevent adding the new file
            }
            return false; // keep the file in the list
          }}

          onRemove={(file) => {
            if (file.url) {
              handleDeleteImage(file.url);
            }
          }}
        >
          <Button icon={<UploadOutlined />}>Upload</Button>
        </Upload>
      </Form.Item>

      <Form.Item
        name="page_slug"
        label="Page Slug"
      >
        <Input placeholder="Enter Page Slug" />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Save Service
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AddS;
